import React from "react";
import { MdInbox } from "react-icons/md";

export type EmptyStateProps = {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
};

export default function EmptyState({ icon, title, description, action, className = "" }: EmptyStateProps) {
  return (
    <div
      className={`flex min-h-[200px] flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-gray-50/80 p-8 text-center dark:border-white/[0.08] dark:bg-surface-elevated/60 ${className}`.trim()}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-100 bg-white text-brand-500 shadow-sm dark:border-white/[0.08] dark:bg-input dark:shadow-none">
        {icon ?? <MdInbox className="h-6 w-6" />}
      </div>
      <div>
        <p className="text-sm font-semibold text-gray-800 dark:text-slate-50">{title}</p>
        {description ? (
          <p className="mt-1 text-xs text-gray-500 dark:text-slate-400">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
